import * as storeTypes from './user.store-types';
import axios from 'axios';
import {User} from './models/user.models';

export default {
    namespaced: true,
    state: {
        isLoading: false,
        isActiveRequest: false,
        selectedUser: new User,
        isModalVisible: false,
        userData: {},
        userDashboard: {},
    },
    mutations: {
        [storeTypes.SET_SELECTED_USER]: (state, selectedUser) => state.selectedUser = selectedUser,
        [storeTypes.SET_IS_MODAL_VISIBLE]: (state, isModalVisible) => state.isModalVisible = isModalVisible,
        [storeTypes.SET_IS_LOADING]: (state, isLoading) => state.isLoading = isLoading,
        [storeTypes.SET_IS_ACTIVE_REQUEST]: (state, isActiveRequest) => state.isActiveRequest = isActiveRequest,
        [storeTypes.SET_USER_DATA]: (state, userData) => state.userData = userData,
        [storeTypes.SET_USER_DASHBOARD]: (state, userDashboard) => state.userDashboard = userDashboard,
    },
    actions: {
        async [storeTypes.ACTION_GET_USER_DATA](store, {companyId, userId}) {
            store.commit(storeTypes.SET_IS_LOADING, true);

            return new Promise((resolve, reject) => {
                (async () => {
                    try {
                        const {data: {success, error, data}} = await axios.get(`/api/companies/${companyId}/users/${userId}/summary`);

                        if (!success) {
                            return reject(error);
                        }

                        store.commit(storeTypes.SET_USER_DATA, data);

                        resolve(data);
                    } catch ({response: {data: {error}}}) {
                        reject(error);
                    } finally {
                        store.commit(storeTypes.SET_IS_LOADING, false);
                    }
                })();
            });
        },
        async [storeTypes.ACTION_GET_USERS](store, {companyId = '', name = ''}) {
            store.commit(storeTypes.SET_IS_LOADING, true);

            return new Promise((resolve, reject) => {
                (async () => {
                    try {
                        const {data: {success, error, users}} = await axios.get(`/api/companies/${companyId}/users?name=${name}`);

                        if (!success) {
                            return reject(error);
                        }

                        resolve(users.map(user => User.fromArray(user)));
                    } catch ({response: {data: {error}}}) {
                        reject(error);
                    } finally {
                        store.commit(storeTypes.SET_IS_LOADING, false);
                    }
                })();
            });
        },
        async [storeTypes.ACTION_ADD_USER](store, {companyId, user, sendCreateMail}) {
            store.commit(storeTypes.SET_IS_ACTIVE_REQUEST, true);

            return new Promise((resolve, reject) => {
                (async () => {
                    try {
                        const {data: {success}} = await axios.post(`/api/companies/${companyId}/users`, {user, sendCreateMail});

                        if (success) {
                            return resolve();
                        }
                    } catch ({response: {data: {error}}}) {
                        reject(error);
                    } finally {
                        store.commit(storeTypes.SET_IS_ACTIVE_REQUEST, false);
                    }
                })();
            });
        },
        async [storeTypes.ACTION_UPDATE_USER](store, {companyId, user}) {
            store.commit(storeTypes.SET_IS_ACTIVE_REQUEST, true);

            return new Promise((resolve, reject) => {
                (async () => {
                    try {
                        const {data: {success}} = await axios.put(`/api/companies/${companyId}/users/${user._id}`, {user});

                        if (success) {
                            return resolve();
                        }
                    } catch ({response: {data: {error}}}) {
                        reject(error);
                    } finally {
                        store.commit(storeTypes.SET_IS_ACTIVE_REQUEST, false);
                    }
                })();
            });
        },
        async [storeTypes.ACTION_REMOVE_USER](store, {companyId, userId}) {
            store.commit(storeTypes.SET_IS_ACTIVE_REQUEST, true);

            return new Promise((resolve, reject) => {
                (async () => {
                    try {
                        const {data: {success}} = await axios.delete(`/api/companies/${companyId}/users/${userId}`);

                        if (success) {
                            return resolve();
                        }
                    } catch ({response: {data: {error}}}) {
                        reject(error);
                    } finally {
                        store.commit(storeTypes.SET_IS_ACTIVE_REQUEST, false);
                    }
                })();
            });
        },
        async [storeTypes.ACTION_EXPORT_USERS](store, companyId) {
            store.commit(storeTypes.SET_IS_ACTIVE_REQUEST, true);

            return new Promise((resolve, reject) => {
                (async () => {
                    try {
                        const {data: {success, csvPath}} = await axios.get(`/api/companies/${companyId}/users/export`);

                        if (success) {
                            return resolve(csvPath);
                        }
                    } catch ({response: {data: {error}}}) {
                        reject(error);
                    } finally {
                        store.commit(storeTypes.SET_IS_ACTIVE_REQUEST, false);
                    }
                })();
            });
        },
        async [storeTypes.ACTION_IMPORT_USERS](store, {companyId, users, sendCreateMail}) {
            store.commit(storeTypes.SET_IS_ACTIVE_REQUEST, true);

            return new Promise((resolve, reject) => {
                (async () => {
                    try {
                        const {data: {success}} = await axios.post(`/api/companies/${companyId}/users/import`, {users, sendCreateMail});

                        if (success) {
                            return resolve();
                        }
                    } catch ({response: {data: {error}}}) {
                        reject(error);
                    } finally {
                        store.commit(storeTypes.SET_IS_ACTIVE_REQUEST, false);
                    }
                })();
            });
        },
        async [storeTypes.ACTION_GET_USER_DASHBOARD](store, {companyId, userId}) {
            store.commit(storeTypes.SET_IS_LOADING, true);

            return new Promise((resolve, reject) => {
                (async () => {
                    try {
                        const {data: {success, error, data}} = await axios.get(`/api/companies/${companyId}/users/${userId}/dashboard`);

                        if (!success) {
                            return reject(error);
                        }

                        store.commit(storeTypes.SET_USER_DASHBOARD, data);

                        resolve(data);
                    } catch ({response: {data: {error}}}) {
                        reject(error);
                    } finally {
                        store.commit(storeTypes.SET_IS_LOADING, false);
                    }
                })();
            });
        },
        async [storeTypes.ACTION_SHOW_MODAL](store, user = null) {
            if (user) {
                store.commit(storeTypes.SET_SELECTED_USER, User.fromArray(user));
            }

            store.commit(storeTypes.SET_IS_MODAL_VISIBLE, true);
        },
        async [storeTypes.ACTION_HIDE_MODAL](store) {
            store.commit(storeTypes.SET_SELECTED_USER, new User);
            store.commit(storeTypes.SET_IS_MODAL_VISIBLE, false);
        },
    },
    getters: {
        [storeTypes.GET_SELECTED_USER]: state => state.selectedUser,
        [storeTypes.GET_IS_MODAL_VISIBLE]: state => state.isModalVisible,
        [storeTypes.GET_IS_LOADING]: state => state.isLoading,
        [storeTypes.GET_IS_ACTIVE_REQUEST]: state => state.isActiveRequest,
        [storeTypes.GET_USER_DATA]: state => state.userData,
        [storeTypes.GET_USER_DASHBOARD]: state => state.userDashboard,
    },
}